export const backgroundColors = ['white', 'gray', 'dark']

export const variants = ['Template01', 'Template02', 'Template03']
